export function setJSONValue<A>(key: string, value: A): void {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export function setSafeJSONValue<A>(key: string, value: A): void {
  try {
    setJSONValue(key, value)
  } catch {
    console.log(`Error setting ${key} in localStorage`)
  }
}

export function getJSONValue<R>(key: string): R | null {
  const item = window.localStorage.getItem(key)

  if (item) {
    return JSON.parse(item) as R
  }

  return null
}

export const getSafeJSONValue = <R>(key: string): R | null => {
  try {
    return getJSONValue(key)
  } catch {
    return null
  }
}

export const removeJSONValue = (key: string): void => {
  window.localStorage.removeItem(key)
}
